<template>

    <div v-if="fetcher.initialized">

        <h2>Företagsuppgifter</h2>

        <div class="row">
            <div class="col-md-12">

                <div class="custom-form-section">

                    <input-text
                        type="text"
                        name="name"
                        label="Företagsnamn*"
                        v-model="company.name"
                        customErrorMessage="Ange ett namn på företaget"
                    />

                    <input-text
                        type="text"
                        name="organization_number"
                        label="Organisationsnummer"
                        placeholder="XXXXXX-XXXX"
                        v-model="company.organization_number"
                        customErrorMessage="Ange ett korrekt organisationsnummer på 10 siffror"
                    />

                    <input-text
                        type="text"
                        name="address_street_1"
                        label="Adress"
                        v-model="company.address_street_1"
                    />

                    <input-text
                        type="text"
                        name="address_street_2"
                        label="Adress rad 2"
                        v-model="company.address_street_2"
                    />

                    <div class="row g-3">
                        <div class="col-md-8">
                            <input-text
                                type="number"
                                name="address_zip"
                                label="Postnummer"
                                v-model="company.address_zip"
                            />
                        </div>
                        <div class="col-md-16">
                            <input-text
                                type="text"
                                name="address_city"
                                label="Ort"
                                v-model="company.address_city"
                            />
                        </div>
                    </div>

                    <input-text
                        type="text"
                        name="invoice_email"
                        label="E-post för faktura"
                        v-model="company.invoice_email"
                    />

                </div>

            </div>

            <div class="col-md-12">

                <div class="custom-form-section">

                    <input-select
                        name="status"
                        label="Status"
                        v-model="company.status"
                        :options="[
                            {value: 'Prospect', label: 'Prospect'},
                            {value: 'Aktiv', label: 'Aktiv'},
                            {value: 'Inaktiv', label: 'Inaktiv'},
                            {value: 'Avslutad', label: 'Avslutad'},
                            {value: 'Inaktivt prospect', label: 'Inaktivt prospect'},
                        ]"
                    />

                    <input-text
                        type="number"
                        name="priority"
                        label="Prio"
                        v-model="company.priority"
                    />

                </div>

            </div>

        </div>

        <div class="row mt-8">

            <div class="col-md-12">

                <h2>Företagets avtalsansvariga</h2>

                <div class="custom-form-section mb-2">

                    <div class="row g-3">
                        <div class="col-md-12">
                            <input-text
                                type="text"
                                name="contract_name"
                                label="Namn"
                                v-model="company.contract_name"
                            />
                        </div>
                        <div class="col-md-12">
                            <input-text
                                type="text"
                                name="contract_title"
                                label="Titel"
                                v-model="company.contract_title"
                            />
                        </div>
                        <div class="col-md-12">
                            <input-text
                                type="text"
                                name="contract_email"
                                label="E-post"
                                v-model="company.contract_email"
                                customErrorMessage="Ange en korrekt e-postadress"
                            />
                        </div>
                        <div class="col-md-12">
                            <input-text
                                type="text"
                                name="contract_phone_1"
                                label="Telefonnummer 1"
                                v-model="company.contract_phone_1"
                            />
                        </div>
                        <div class="col-md-12">
                            <input-text
                                type="text"
                                name="contract_phone_2"
                                label="Telefonnummer 2"
                                v-model="company.contract_phone_2"
                            />
                        </div>
                    </div>

                </div>

            </div>

            <div class="col-md-12">

                <h2>Hälsoresurs kontaktpersoner</h2>

                <div class="custom-form-section mb-2">

                    <label class="form-label">Avtalsansvarig</label>
                    <input-select
                        name="admin_id_contract"
                        formGroupClass="mb-1"
                        v-model="company.admin_id_contract"
                        :options="adminOptions"
                        />

                    <div class="row mt-8 mb-4">
                        <div class="col">
                            <label class="form-label">Kontaktperson 1</label>
                            <input-select
                                name="admin_id_contact_1"
                                formGroupClass="mb-1"
                                v-model="company.admin_id_contact_1"
                                :options="adminOptions"
                            />
                        </div>
                        <div class="col">
                            <label class="form-label">Kontaktperson 2</label>
                            <input-select
                                name="admin_id_contact_2"
                                formGroupClass="mb-1"
                                v-model="company.admin_id_contact_2"
                                :options="adminOptions"
                            />
                        </div>

                    </div>

                </div>

            </div>

        </div>

        <div class="d-flex justify-content-end mt-8 mb-12">
            <button class="btn btn-primary" :disabled="patcher.submitted" @click="patcherPatch()">
                <span class="spinner-border spinner-border-sm"></span>
                Spara uppgifter
            </button>
        </div>

        <gdpr-buttons :company="company" />

    </div>

</template>

<script>

import fetcher from '../../../../shared/mixins/fetcher'
import patcher from '../../../../shared/mixins/patcher'

import gdprButtons from './gdpr-buttons.vue'

export default {

    mixins: [
        fetcher,
        patcher
    ],

    components: {
        gdprButtons
    },

    props: {
        company_id: {
            required: true
        }
    },

    data () {
        return {
            company: null,
            admins: [],
            fetcher: {
                autoFill: [
                    'company',
                    'admins'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/companies/' + this.company_id + '/companySettingsTab'
        },
        patcherUrl () {
            return '/companies/' + this.company_id
        },
        patcherData () {
            return {
                name: this.company.name,
                organization_number: this.company.organization_number,
                address_street_1: this.company.address_street_1,
                address_street_2: this.company.address_street_2,
                address_zip: this.company.address_zip,
                address_city: this.company.address_city,
                invoice_email: this.company.invoice_email,
                status: this.company.status,
                priority: this.company.priority,
                contract_name: this.company.contract_name,
                contract_title: this.company.contract_title,
                contract_email: this.company.contract_email,
                contract_phone_1: this.company.contract_phone_1,
                contract_phone_2: this.company.contract_phone_2,
                admin_id_contract: this.company.admin_id_contract,
                admin_id_contact_1: this.company.admin_id_contact_1,
                admin_id_contact_2: this.company.admin_id_contact_2
            }
        },
        adminOptions () {
            const options = [{ value: null, label: 'Välj...' }]
            this.admins.forEach(a => {
                options.push({ value: a.id, label: a.name })
            })
            return options
        }
    },

    methods: {
        patcherSuccess (data) {
            bus.$emit(
                'notify',
                'Uppgifterna har sparats'
            )
            location.reload()
        }
    }

}
</script>
